// Корректирую пришедшие данные (удаляю всё ненужное и убираю лишнюю вложенность)
import moment from "moment";
import { message, Modal } from "antd";

export const dataAdjustmentResponse = order => {
  // console.log(order);
  let newData = {
    id: order.orderId,
    offerId: order.offerId && order.offerId.offerId,
    orderName: "",
    requestId: order.offerId.requestId.requestId,
    comment: order.offerId.comment,
    orderStatus: order.orderStatusId && order.orderStatusId.orderStatusKey, // Статус заказа
    orderStatusName: order.orderStatusId && order.orderStatusId.orderStatus, // Текстовое название статуса
    number: order && order.number, // Номер заказа,
    customer:
      order.offerId &&
      order.offerId.requestId &&
      order.offerId.requestId.profileId &&
      order.offerId.requestId.profileId.companyId &&
      order.offerId.requestId.profileId.companyId.subjectId &&
      order.offerId.requestId.profileId.companyId.subjectId.subjectKey ===
        "physical"
        ? (order.offerId &&
            order.offerId.requestId &&
            order.offerId.requestId.profileId &&
            order.offerId.requestId.profileId.companyId &&
            order.offerId.requestId.profileId.companyId.lastname) ||
          ("" + order.offerId &&
            order.offerId.requestId &&
            order.offerId.requestId.profileId &&
            order.offerId.requestId.profileId.companyId &&
            order.offerId.requestId.profileId.companyId.name) ||
          ("" + order.offerId &&
            order.offerId.requestId &&
            order.offerId.requestId.profileId &&
            order.offerId.requestId.profileId.companyId &&
            order.offerId.requestId.profileId.companyId.patronymic) ||
          ""
        : order.offerId &&
          order.offerId.requestId &&
          order.offerId.requestId.profileId &&
          order.offerId.requestId.profileId.companyId &&
          order.offerId.requestId.profileId.companyId.nameLegal, // Заказчик
    phoneCode:
      order.offerId &&
      order.offerId.requestId &&
      order.offerId.requestId.profileId &&
      order.offerId.requestId.profileId.companyId &&
      order.offerId.requestId.profileId.companyId.phoneCode, // Код телефона
    phoneNumber:
      order.offerId.requestId &&
      order.offerId.requestId.profileId &&
      order.offerId.requestId.profileId.companyId &&
      order.offerId.requestId.profileId.companyId.phone, // Номер телефона
    email:
      order.offerId.requestId &&
      order.offerId.requestId.profileId &&
      order.offerId.requestId.profileId.companyId &&
      order.offerId.requestId.profileId.companyId.email, // Почта
    serviceType:
      order.offerId &&
      order.offerId.requestId &&
      order.offerId.requestId.serviceTypeId &&
      order.offerId.requestId.serviceTypeId.serviceTypeKey, // Вид транспортной услуги

    passengersCount:
      order.offerId &&
      order.offerId.requestId &&
      order.offerId.requestId.passengersCount &&
      parseInt(order.offerId.requestId.passengersCount), // Количество пассажиров
    accompCount:
      order.offerId &&
      order.offerId.requestId &&
      order.offerId.requestId.accompCount &&
      parseInt(order.offerId.requestId.accompCount), // Количество сопровождающих
    kidsCount:
      order.offerId &&
      order.offerId.requestId &&
      order.offerId.requestId.kidsCount &&
      parseInt(order.offerId.requestId.kidsCount), // Количество детей
    workersCount:
      order.offerId &&
      order.offerId.requestId &&
      order.offerId.requestId.workersCount &&
      parseInt(order.offerId.requestId.workersCount), // Количество сотрудников
    medWorkersCount:
      order.offerId &&
      order.offerId.requestId &&
      order.offerId.requestId.medWorkersCount &&
      parseInt(order.offerId.requestId.medWorkersCount), // Количество медработников
    gibddMail: order.offerId && order.offerId.emailgibdd,
    passengerCode: order.passengerCode,
    performer:
      order.offerId.executors &&
      order.offerId.executors.length > 0 &&
      order.offerId.executors[0].companyId &&
      order.offerId.executors[0].companyId.companyId,
    dispatcher:
      order.offerId.responsible &&
      order.offerId.responsible.length > 0 &&
      order.offerId.responsible[0].profileId,
    responsible:
      order.offerId.responsible &&
      order.offerId.responsible.length > 0 &&
      order.offerId.responsible[0],
    vehicleType:
      order.offerId &&
      order.offerId.vehicleId &&
      order.offerId.vehicleId.vehicleTypeId,
    vehicle: `${order.offerId &&
      order.offerId.vehicleId &&
      order.offerId.vehicleId.vehicleModelId.vehicleBrandId &&
      order.offerId.vehicleId.vehicleModelId.vehicleBrandId
        .brandName} ${order.offerId &&
      order.offerId.vehicleId &&
      order.offerId.vehicleId.vehicleModelId.modelName}, ${order.offerId &&
      order.offerId.vehicleId &&
      order.offerId.vehicleId.registerSign}${order.offerId &&
      order.offerId.vehicleId &&
      order.offerId.vehicleId.registerRegion}`,
    vehicleId:
      order.offerId &&
      order.offerId.vehicleId &&
      order.offerId.vehicleId.vehicleId,
    driver:
      order.offerId &&
      order.offerId.drivers &&
      order.offerId.drivers.length > 0 &&
      order.offerId.drivers[0].userId &&
      order.offerId.drivers[0].userId.lastname &&
      order.offerId.drivers[0].userId.name &&
      order.offerId.drivers[0].userId.patronymic
        ? `${order.offerId.drivers[0].userId.lastname} ${order.offerId.drivers[0].userId.name[0]}. ${order.offerId.drivers[0].userId.patronymic[0]}.`
        : null,
    driverId:
      order.offerId &&
      order.offerId.drivers &&
      order.offerId.drivers.length > 0 &&
      order.offerId.drivers[0].profileId
        ? order.offerId.drivers[0].profileId
        : null,
    priceNoNds: order.offerId && order.offerId.price,
    deviation: !!order.offerId.requestId.deviation,
    payroad: !!order.offerId.requestId.payroad
  };

  if (
    order.offerId &&
    order.offerId.requestId &&
    order.offerId.requestId.routes
  ) {
    newData["startPlace"] =
      order.offerId.requestId.routes && order.offerId.requestId.routes.length
        ? order.offerId.requestId.routes[0].route
        : ""; // Место подачи ТС
    newData["endPlace"] =
      order.offerId.requestId.routes && order.offerId.requestId.routes.length
        ? order.offerId.requestId.routes[
            order.offerId.requestId.routes.length - 1
          ].route
        : ""; // Конечный пункт
    newData["arrivalDatetime"] =
      order.offerId.requestId.arrivalDatetime &&
      moment(order.offerId.requestId.arrivalDatetime);
    newData["routes"] = order.offerId.requestId.routes;
    order.offerId.requestId.routes.forEach((route, index) => {
      newData["routeDuration" + index] = moment(route.duration, "HH:mm");
      newData["route" + index] = route.route;
      newData["routeId" + index] = route.routeId;
      newData["latitude" + index] = route.latitude;
      newData["longitude" + index] = route.longitude;
    });
  }

  if (
    order.offerId &&
    order.offerId.responsibleDocumentsList &&
    order.offerId.responsibleDocumentsList.length > 0
  ) {
    newData.responsibleDocumentsList = order.offerId.responsibleDocumentsList;
    order.offerId.responsibleDocumentsList.forEach(item => {
      newData[item.documentTypeKey] = item.isClient;
    });
  }

  if (
    order.offerId &&
    order.offerId.payments &&
    order.offerId.payments.length > 0
  ) {
    const offer = order.offerId;
    newData.predPayChecked = false;
    newData.payChecked = false;
    newData.postPayChecked = false;
    newData[`predPay`] = [];
    newData[`pay`] = [];
    newData[`postPay`] = [];
    let predPay = [];
    let postPay = [];

    newData.surchargePaymentDate =
      offer.payments[0].paymentTimeAdd &&
      moment(offer.payments[0].paymentTimeAdd);
    newData.refundFreighterDate =
      offer.payments[0].returnTime && moment(offer.payments[0].returnTime);
    newData.priceAddPayment = offer.payments[0].paymentMethodId;

    offer.payments.forEach((item, index) => {
      // Определяем состояние чекбоксов для
      switch (item.paymentTypeId) {
        case 1: {
          if (!newData.predPayChecked) {
            newData.predPayChecked = true;
          }
          predPay.push(item);
          break;
        }
        case 2: {
          if (!newData.payChecked) {
            newData.payChecked = true;
            newData[`payPrice`] = item.payment;
            newData[`payType`] = item.paymentTypeId;
            newData[`paymentTime`] =
              (order.offerId.requestId.arrivalDatetime &&
                moment(order.offerId.requestId.arrivalDatetime)) ||
              null;
          }
          break;
        }
        case 3: {
          if (!newData.postPayChecked) {
            newData.postPayChecked = true;
          }
          postPay.push(item);
          break;
        }
        default: {
          return;
        }
      }

      predPay.forEach((item, index) => {
        newData[`predPayPrice${index}`] = item.payment;
        newData[`predPayType${index}`] = item.paymentTypeId;
        newData[`predPaymentTime${index}`] = moment(item.paymentTime);
      });

      predPay.forEach((_, index) => {
        newData.predPay[index] = index;
      });

      postPay.forEach((item, index) => {
        newData[`postPayPrice${index}`] = item.payment;
        newData[`postPayType${index}`] = item.paymentTypeId;
        newData[`postPaymentTime${index}`] = moment(item.paymentTime);
      });

      postPay.forEach((_, index) => {
        newData.postPay[index] = index;
      });
    });
  }

  if (
    order.offerId &&
    order.offerId.servicesAdditional &&
    order.offerId.servicesAdditional.length > 0
  ) {
    const offer = order.offerId;

    newData.additionalServices = offer.servicesAdditional.map(
      item => item.serviceAdditionalKey
    );

    offer.servicesAdditional.forEach((item, index) => {
      newData["serviceAdditionalPrice" + item.serviceAdditionalKey] =
        item.pivot.serviceAdditionalPrice;
    });
  }

  if (order.offerId) {
    const offer = order.offerId;

    if (offer.t2) {
      newData.t2 = offer.t2;
    }
    if (offer.t4) {
      newData.t4 = offer.t4;
    }
    if (offer.t6) {
      newData.t6 = offer.t6;
    }
    if (offer.t7) {
      newData.t7 = offer.t7;
    }
    if (offer.t8) {
      newData.t8 = offer.t8;
    }
    if (offer.t9) {
      newData.t9 = offer.t9;
    }
    if (offer.sh1) {
      newData.sh1 = offer.sh1;
    }
    if (offer.sh2) {
      newData.sh2 = offer.sh2;
    }
    if (offer.sh3) {
      newData.sh3 = offer.sh3;
    }
    if (offer.kp1t) {
      newData.kp1t = offer.kp1t;
    }
    if (offer.kp1p) {
      newData.kp1p = offer.kp1p;
    }
    if (offer.kp2t) {
      newData.kp2t = offer.kp2t;
    }
    if (offer.kp2p) {
      newData.kp2p = offer.kp2p;
    }
    if (offer.kp3t) {
      newData.kp3t = offer.kp3t;
    }
    if (offer.kp3p) {
      newData.kp3p = offer.kp3p;
    }
    if (offer.kp4t) {
      newData.kp4t = offer.kp4t;
    }
    if (offer.kp4p) {
      newData.kp4p = offer.kp4p;
    }
    if (offer.kz1t) {
      newData.kz1t = offer.kz1t;
    }
    if (offer.kz1p) {
      newData.kz1p = offer.kz1p;
    }
    if (offer.kz2t) {
      newData.kz2t = offer.kz2t;
    }
    if (offer.kz2p) {
      newData.kz2p = offer.kz2p;
    }
    if (offer.kz3t) {
      newData.kz3t = offer.kz3t;
    }
    if (offer.kz3p) {
      newData.kz3p = offer.kz3p;
    }
    if (offer.kz4t) {
      newData.kz4t = offer.kz4t;
    }
    if (offer.kz4p) {
      newData.kz4p = offer.kz4p;
    }
    if (offer.s1) {
      newData.s1 = offer.s1;
    }
    if (offer.kp1rcDatetime) {
      newData.kp1urc = moment(offer.kp1rcDatetime);
    }
  }
  if (order.offerId && order.offerId.responsibleDocumentsList) {
    newData.responsibleDocumentsList = order.offerId.responsibleDocumentsList;
    newData.responsibleDocumentsKeyList = order.offerId.responsibleDocumentsList.map(
      item => item.documentTypeKey
    );
    order.offerId.responsibleDocumentsList.forEach(item => {
      newData[item.documentTypeKey] = !!item.isClient;
    });
  }

  return newData;
};

export const orderErrorResponse = data => {
  let newData = {};
  if (data && data.errors) {
    const err = data.errors;
    if (err.order) {
      if (err.order.order_status_key) {
        newData.orderStatus = err.order.order_status_key;
      }
    }
    if (err.offer) {
      if (err.offer.number) {
        newData.offerNumber = err.offer.number;
      } // todo должно создаваться автоматом
      if (err.offer.vehicle_id) {
        newData.selectedVehicle = err.offer.vehicle_id;
      }
    }
    if (err.request) {
      if (err.request.number) {
        newData.requestNumber = err.request.number;
      } // todo должно создаваться автоматом
      if (err.request.service_type_key) {
        newData.serviceType = err.request.service_type_key;
      }
      if (err.request.request_type_key) {
        newData.requestType = err.request.request_type_key;
      } // todo разобраться Укажите Тип Заявки (KEY)
      if (err.request.request_view_key) {
        newData.requestView = err.request.request_view_key;
      } // todo разобраться Укажите Представление Заявки (KEY)
      if (err.request.payment_method_id) {
        newData.paymentMethod = err.request.payment_method_id;
      } // todo разобраться Укажите Метод оплаты (ID)
    }
    if (err.profile) {
      if (err.profile.role_key) {
        newData.role = err.profile.role_key;
      } // todo разобраться Укажите Роль (KEY)
      if (err.profile.profile_status_id) {
        newData.profileStatus = err.profile.profile_status_id;
      } // todo разобраться Укажите Статус
    }
    if (err.user) {
      if (err.user.phone) {
        newData.phone = err.user.phone;
      } // todo разобраться чем имеено мобильный
      if (err.user.citizenship_id) {
        newData.citizenship = err.citizenship_id;
      } // todo разобраться Укажите Гражданство (ID)
      if (err.user.sex_id) {
        newData.sex = err.profile.sex_id;
      } // todo разобраться Укажите Пол (ID)
    }
    if (err.company) {
      if (err.company.subject_key) {
        newData.subject = err.company.subject_key;
      } // todo разобраться Укажите Субъект (key)
      if (err.company.teleportos_account_id) {
        newData.teleportosAccount = err.company.teleportos_account_id;
      } // todo разобраться Укажите Счет Teleportos (ID)
      if (err.company.inn) {
        newData.inn = err.company.inn;
      } // todo разобраться Укажите ИНН
    }
  }

  return newData;
};

// Корректирую данные для отправки
export const dataCreateOrderRequest = async (data, ymaps) => {
  let newData = {
    request: {},
    offer: {},
    order: {}
  };
  newData.offer.emailgibdd = data.gibddMail;
  newData.offer_id = data.offerId;
  newData.request_id = data.requestId;
  newData.offer.t2 = data.t2;
  newData.offer.t4 = data.t4;
  newData.offer.t6 = data.t6;
  newData.offer.t7 = data.t7;
  newData.offer.t8 = data.t8;
  newData.offer.t9 = data.t9;
  newData.offer.sh1 = data.sh1;
  newData.offer.sh2 = data.sh2;
  newData.offer.sh3 = data.sh3;
  newData.offer.kp1t = data.kp1t;
  newData.offer.kp2t = data.kp2t;
  newData.offer.kp3t = data.kp3t;
  newData.offer.kp4t = data.kp4t;
  newData.offer.kp1p = data.kp1p;
  newData.offer.kp2p = data.kp2p;
  newData.offer.kp3p = data.kp3p;
  newData.offer.kp4p = data.kp4p;
  newData.offer.kz1t = data.kz1t;
  newData.offer.kz2t = data.kz2t;
  newData.offer.kz3t = data.kz3t;
  newData.offer.kz4t = data.kz4t;
  newData.offer.kz1p = data.kz1p;
  newData.offer.kz2p = data.kz2p;
  newData.offer.kz3p = data.kz3p;
  newData.offer.kz4p = data.kz4p;
  newData.offer.kp1rc_datetime =
    data.kp1urc && data.kp1urc.format("YYYY-MM-DD HH:mm:ss");
  newData.offer.vehicle_id = data.vehicleId;
  if (data.driver) {
    newData.offer.driver_name = data.driver;
  }
  if (data.driverId) {
    newData.offer.drivers = [data.driverId];
  }
  newData.offer.price = data.priceNoNds;
  newData.offer.total_price = data.totalPrice;
  newData.offer.vehicle_type_id =
    data.vehicleTypeId === "Автобус"
      ? 1
      : data.vehicleTypeId === "Микроавтобус"
      ? 2
      : 3;

  newData.offer.company_executor_id = data.performer;
  newData.offer.responsible_id = data.dispatcher;

  newData.offer.arrival_datetime =
    (data.arrivalDatetime &&
      data.arrivalDatetime.format("YYYY-MM-DD HH:mm:ss")) ||
    null;
  newData.request.arrival_datetime =
    (data.arrivalDatetime &&
      data.arrivalDatetime.format("YYYY-MM-DD HH:mm:ss")) ||
    null;

  if (
    data.responsibleDocumentsKeyList &&
    data.responsibleDocumentsKeyList.length > 0
  ) {
    newData.offer.responsible_documents_list =
      data.serviceType === "simple"
        ? data.noFreightOrder
          ? ["plist", "wo", "receipt", "waybill", "ra", "ordrep"]
          : ["plist", "cc", "wo", "receipt", "waybill", "ra", "ordrep"]
        : data.serviceType === "kids"
        ? data.noFreightOrder
          ? [
              "clist",
              "alist",
              "workphys",
              "fplist",
              "kidsnight",
              "arrland",
              "hwi",
              "di",
              "rp",
              "gn",
              "gi",
              "wo",
              "waybill",
              "receipt",
              "ra",
              "ordrep"
            ]
          : [
              "clist",
              "alist",
              "workphys",
              "fplist",
              "kidsnight",
              "arrland",
              "hwi",
              "di",
              "rp",
              "gn",
              "gi",
              "cc",
              "wo",
              "waybill",
              "receipt",
              "ra",
              "ordrep"
            ]
        : data.serviceType === "undefined"
        ? data.noFreightOrder
          ? ["wo", "waybill", "receipt", "ra", "ordrep"]
          : ["cc", "wo", "waybill", "receipt", "ra", "ordrep"]
        : null;
    data.responsibleDocumentsKeyList.forEach(key => {
      if (
        newData.offer.responsible_documents_list &&
        newData.offer.responsible_documents_list.length > 0
      ) {
        newData.offer.responsible_documents_list.push({
          is_client: data[key],
          document_type_key: key
        });
      } else {
        newData.offer.responsible_documents_list[0] = {
          is_client: data[key],
          document_type_key: key
        };
      }
    });
  }

  if (data.serviceType) {
    switch (data.serviceType) {
      case "simple": {
        data.responsibleDocumentsKeyList = data.noFreightOrder
          ? ["plist", "wo", "receipt", "waybill", "ra", "ordrep"]
          : ["plist", "cc", "wo", "receipt", "waybill", "ra", "ordrep"];
        break;
      }
      case "kids": {
        data.responsibleDocumentsKeyList = data.noFreightOrder
          ? [
              "clist",
              "alist",
              "workphys",
              "fplist",
              "kidsnight",
              "arrland",
              "hwi",
              "di",
              "rp",
              "gn",
              "gi",
              "wo",
              "waybill",
              "receipt",
              "ra",
              "ordrep"
            ]
          : [
              "clist",
              "alist",
              "workphys",
              "fplist",
              "kidsnight",
              "arrland",
              "hwi",
              "di",
              "rp",
              "gn",
              "gi",
              "cc",
              "wo",
              "waybill",
              "receipt",
              "ra",
              "ordrep"
            ];
        break;
      }
      case "undefined": {
        data.responsibleDocumentsKeyList = data.noFreightOrder
          ? ["wo", "waybill", "receipt", "ra", "ordrep"]
          : ["cc", "wo", "waybill", "receipt", "ra", "ordrep"];
        break;
      }
      default: {
        break;
      }
    }
    data.responsibleDocumentsKeyList.forEach(key => {
      if (
        newData.offer.responsible_documents_list &&
        newData.offer.responsible_documents_list.length > 0
      ) {
        newData.offer.responsible_documents_list.push({
          is_client: data[key],
          document_type_key: key
        });
      } else {
        newData.offer.responsible_documents_list = [
          {
            is_client: data[key],
            document_type_key: key
          }
        ];
      }
    });
  }

  if (data.predPay || data.pay || data.postPay) {
    newData.offer.payments = [];
    if (data.predPayChecked && data.predPay && data.predPay.length > 0) {
      data.predPay.forEach(item => {
        if (data[`predPayPrice${item}`] && data[`predPaymentTime${item}`]) {
          newData.offer.payments.push({
            payment_type_id: 1,
            payment: data[`predPayPrice${item}`],
            payment_time:
              data[`predPaymentTime${item}`] &&
              data[`predPaymentTime${item}`].format("YYYY-MM-DD HH:mm:ss")
          });
        } else if (
          data[`predPayPrice${item}`] &&
          !data[`predPaymentTime${item}`]
        ) {
          throw new Error("Укажите дату предоплаты");
          // message.error("Укажите дату предоплаты");
        }
      });
    }
    if (data.payChecked && data.pay && data.pay.length > 0) {
      if (data[`payPrice`]) {
        newData.offer.payments.push({
          payment_type_id: 2,
          payment: data[`payPrice`],
          payment_time:
            (data[`arrivalDatetime`] &&
              data[`arrivalDatetime`].format("YYYY-MM-DD HH:mm:ss")) ||
            null
        });
      }
    }
    if (data.postPayChecked && data.postPay && data.postPay.length > 0) {
      data.postPay.forEach(item => {
        if (data[`postPayPrice${item}`] && data[`postPaymentTime${item}`]) {
          newData.offer.payments.push({
            payment_type_id: 3,
            payment: data[`postPayPrice${item}`],
            payment_time:
              data[`postPaymentTime${item}`] &&
              data[`postPaymentTime${item}`].format("YYYY-MM-DD HH:mm:ss")
          });
        } else if (
          data[`postPayPrice${item}`] &&
          !data[`postPaymentTime${item}`]
        ) {
          throw new Error("Укажите дату постоплаты");
          // message.error("Укажите дату постоплаты");
        }
      });
    }

    newData.offer.payments = newData.offer.payments.map(item => ({
      ...item,
      payment_time_add:
        data.surchargePaymentDate &&
        data.surchargePaymentDate.format("YYYY-MM-DD HH:mm:ss"),
      return_time:
        data.surchargePaymentDate &&
        data.refundFreighterDate.format("YYYY-MM-DD HH:mm:ss"),
      payment_method_id: data.priceAddPayment
    }));
  }

  if (data.additionalServices && data.additionalServices.length > 0) {
    newData.offer.service_additional = [];
    data.additionalServices.forEach(key => {
      newData.offer.service_additional.push({
        service_additional_key: key,
        service_additional_price: data[`serviceAdditionalPrice${key}`]
      });
    });
  }

  newData.request.service_type_key = data.serviceType;
  if (data.serviceType === "kids") {
    newData.request.kids_count = data.kidsCount;
    newData.request.accomp_count = data.accompCount;
    newData.request.workers_count = data.workersCount;
    newData.request.med_workers_count = data.medWorkersCount;
  } else if (data.serviceType === "simple") {
    newData.request.passengers_count = data.passengersCount;
  }

  newData.routes = data.routes.map((item, index) => {
    return {
      ...item,
      duration: data[`routeDuration${index}`].format("HH:mm")
    };
  });

  if (ymaps) {
    const markers = data.routes.map(route => {
      return [route.latitude, route.longitude];
    });

    await new ymaps.route(markers)
      .then(route => {
        route.getPaths().each((item, index) => {
          if (index !== newData.routes.length) {
            newData.routes[index + 1]["route_length"] =
              item.properties.getAll().RouterRouteMetaData.Length.value &&
              Math.round(
                item.properties.getAll().RouterRouteMetaData.Length.value / 100
              );
            newData.routes[index + 1]["route_time"] =
              item.properties.getAll().RouterRouteMetaData.Time.value &&
              Math.round(
                item.properties.getAll().RouterRouteMetaData.Time.value
              );
          }
        });
      })
      .catch(error => {
        if (error.message === "can't construct a route") {
          Modal.error({
            content: "Проложить наземный маршрут невозможно!",
            title: "Внимание!",
            okText: "Закрыть",
            destroyOnClose: true,
            width: 432
          });
        } else {
          message.error("Произошла ошибка");
        }
        throw new Error();
      });
  }

  newData.request.deviation = !!data.deviation;
  newData.request.payroad = !!data.payroad;

  newData.client_company_id = [data.customerCompany];
  //todo разобраться с этим параметром. Выходит фигня с бэкенда
  newData.client_profile_id = data.customerCompany;

  newData.order = {
    passenger_code: "",
    order_status_key: ""
  };

  newData.offer.offer_status_id = 1;
  newData.order.order_status_key = 2;
  newData.request.request_type_key = "fast";
  newData.request.request_view_key = "straight";

  return newData;
};
